
import { useTranslation } from 'react-i18next';

export default function RequirementsSection() {
  const { t, i18n } = useTranslation();

  const requirements = [
    {
      categoryKey: 'basic_requirements',
      items: i18n.language === 'zh' ? [
        '年满18周岁，具备完全民事行为能力',
        '在主流社交平台拥有活跃账号',
        '内容创作经验不少于6个月',
        '具备基本的英语沟通能力'
      ] : [
        'At least 18 years old with full legal capacity',
        'Active accounts on mainstream social platforms',
        'Content creation experience of at least 6 months',
        'Basic English communication skills'
      ]
    },
    {
      categoryKey: 'follower_requirements',
      items: i18n.language === 'zh' ? [
        'TikTok: 10K+ 粉丝',
        'Instagram: 5K+ 粉丝',
        'YouTube: 1K+ 订阅者',
        '小红书: 1K+ 粉丝'
      ] : [
        'TikTok: 10K+ followers',
        'Instagram: 5K+ followers',
        'YouTube: 1K+ subscribers',
        'Xiaohongshu: 1K+ followers'
      ]
    },
    {
      categoryKey: 'content_quality',
      items: i18n.language === 'zh' ? [
        '原创内容占比80%以上',
        '近30天平均互动率 ≥ 3%',
        '内容风格鲜明，定位清晰',
        '无违规记录，账号状态良好'
      ] : [
        'Original content ratio above 80%',
        'Average engagement rate ≥ 3% in the last 30 days',
        'Distinctive content style and clear positioning',
        'No violation records, good account status'
      ]
    },
    {
      categoryKey: 'cooperation_attitude',
      items: i18n.language === 'zh' ? [
        '积极响应合作需求',
        '按时完成约定任务',
        '接受专业指导和建议',
        '维护品牌形象和声誉'
      ] : [
        'Actively respond to cooperation needs',
        'Complete agreed tasks on time',
        'Accept professional guidance and suggestions',
        'Maintain brand image and reputation'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('requirements_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('requirements_desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {requirements.map((req, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 hover:bg-gray-100 transition-colors duration-300">
              <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">
                {t(req.categoryKey)}
              </h3>
              
              <ul className="space-y-3">
                {req.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <i className="ri-check-circle-fill text-green-500 text-sm mt-1 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            <i className="ri-lightbulb-line text-yellow-500 mr-2"></i>
            {t('tip_title')}
          </h3>
          <p className="text-gray-700 leading-relaxed max-w-4xl mx-auto">
            {t('tip_desc')}
          </p>
        </div>
      </div>
    </section>
  );
}
